"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            SSOToken: null,
            toLink: false,
            provider: null
        };
        GState.bind(this, ['tenant']);
        fhandler.bind(this);
    },
    onInput: function (input) {
        if (input.params.errmess) {
            fhandler.alert(input.params.errmess);
            input.params.next && navigate(input.params.next);
            return;
        }
        if (!input.params.sso_pr) {
            fhandler.alert('Invalid Authentication Link', 'warning');
            setTimeout(() => navigate('/signin'), 15000);
            return;
        }
        this.state.provider = input.params.sso_pr;
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        fhandler.set('country', location);
        UISocket.emit('APP::GET_SSOTOKEN', {
            authType: 'link-account',
            device: window.Device,
            userAgent: window.UserAgent,
            location
        }, token => this.state.SSOToken = token);
    },
    onSubmit: async function () {
        if (this.state.submitting)
            return;
        const Form = this.state.form;
        if (!Form.email)
            return fhandler.error('email', 'Email Address field is required');
        if (!Form.password)
            return fhandler.error('password', 'Password field is required');
        Form.device = window.Device;
        Form.ignore2FA = true;
        Form.linkTo = {
            ctoken: this.input.params.ctoken,
            deviceId: this.input.params.deviceId,
            type: this.input.params.type,
            role: this.input.params.role
        };
        this.state.submitting = true;
        try {
            const {error, message, credentials, next} = await AuthRequest('/signin', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            fhandler.reset();
            next == 'grantaccess' ? setTimeout(() => this.grantAccess(credentials), 2000) : navigate('/' + next);
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    },
    onLinkAccount: function () {
        this.state.toLink = true;
    },
    grantAccess: function (credentials) {
        const {ctoken, deviceId, type, role} = credentials || this.input.params;
        if (!ctoken || !deviceId || !type || !role) {
            fhandler.alert('Invalid Signin Credentials', 'warning');
            setTimeout(() => navigate('/signin'), 15000);
        }
        let queries = Obj2Params({
            ctoken,
            deviceId,
            type,
            role
        });
        if (isDefaultDomain())
            queries += '&redirectTo=/onboarding';
        else {
            if (this.input.params.hasOwnProperty('redirectTo'))
                queries += '&redirectTo=' + encodeURIComponent(this.input.params.redirectTo);
        }
        document.location = `/authorize?${ queries }`;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/LinkAccount.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    TenantLogo_template = require("../../../components/TenantLogo/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    SSOAuth_template = require("../../components/SSOAuth.marko"),
    SSOAuth_tag = marko_loadTag(SSOAuth_template),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-header w-100 text-center pb-0"
      },
    marko_attrs1 = {
        "class": "card-body"
      },
    marko_attrs2 = {
        "class": "mx-50"
      },
    marko_attrs3 = {
        "class": "mb-4"
      },
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("37d6de"),
    marko_node0 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "py-1"
      },
    marko_node1 = marko_createElement("br", null, "28", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "col-3"
      },
    marko_attrs8 = {
        "class": "col text-right"
      },
    marko_attrs9 = {
        "class": "font-medium-5"
      },
    marko_attrs10 = {
        "class": "mt-4 font-small"
      },
    marko_attrs11 = {
        "class": "mt-4 font-small"
      },
    marko_attrs12 = {
        "class": "card-header w-100"
      },
    marko_attrs13 = {
        "class": "card-body"
      },
    marko_attrs14 = {
        "class": "text-center"
      },
    marko_node2 = marko_createElement("br", null, "41", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "42", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs15 = {
        "class": "font-medium-2"
      },
    marko_node4 = marko_createElement("br", null, "46", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs16 = {
        "class": "col-2"
      },
    marko_attrs17 = {
        "class": "col text-right"
      },
    marko_attrs18 = {
        "class": "font-medium-5"
      },
    marko_attrs19 = {
        "class": "btn btn-outline-primary btn-xl text-left btn-block"
      },
    marko_attrs20 = {
        "class": "btn btn-outline-primary btn-xl text-left btn-block"
      },
    marko_attrs21 = {
        "class": "btn btn-primary btn-xl btn-block text-left mt-4"
      };

const fhandler = new FormHandler({ key: 'link-account-form' });

function render(input, out, __component, component, state) {
  var data = input;

  AuthLayout_tag({
      renderBody: function(out) {
        if (state.provider && state.toLink) {
          out.be("div", marko_attrs0, "1", component);

          Row_tag({
              class: "d-flex align-items-center",
              renderBody: function(out) {
                out.be("div", marko_attrs7, "3", component);

                TenantLogo_tag({
                    style: "width:40px"
                  }, out, __component, "4");

                out.ee();

                out.be("div", marko_attrs8, "5", component);

                out.be("h4", marko_attrs9, "6", component);

                Locale_tag({
                    text: "Link your account"
                  }, out, __component, "7");

                out.ee();

                out.ee();
              }
            }, out, __component, "2");

          out.ee();

          out.be("div", marko_attrs1, "8", component);

          FormAlert_tag({
              alert: state.alert,
              class: "mx-50"
            }, out, __component, "9");

          out.be("form", marko_attrs2, "@link-account-form", component);

          out.be("h6", marko_attrs3, "10", component);

          Locale_tag({
              text: "Sign-in"
            }, out, __component, "11");

          out.ee();

          out.be("div", marko_attrs4, "12", component);

          out.e("input", {
              "class": "form-control form-control-xl",
              type: "email",
              required: true,
              name: "email",
              value: state.form.email,
              validate: fhandler.define("email"),
              placeholder: Locale("Email Address")
            }, "13", component, 0, 0, {
              onchange: __component.d("change", "__onChange", false)
            });

          if (state.formError.email) {
            out.be("p", marko_attrs10, "14", component);

            Locale_tag({
                renderBody: function(out) {
                  out.t("Invalid Email Address");
                }
              }, out, __component, "15");

            out.ee();
          }

          out.ee();

          out.be("div", marko_attrs5, "16", component);

          out.e("input", {
              "class": "form-control form-control-xl",
              type: "password",
              required: true,
              name: "password",
              value: state.form.password,
              placeholder: Locale("Password")
            }, "17", component, 0, 0, {
              onchange: __component.d("change", "__onChange", false)
            });

          if (state.formError.password) {
            out.be("p", marko_attrs11, "18", component);

            Locale_tag({
                renderBody: function(out) {
                  out.t("Invalid Password");
                }
              }, out, __component, "19");

            out.ee();
          }

          out.ee();

          out.n(marko_node0, component);

          out.be("button", {
              type: "submit",
              disabled: state.submitting,
              "class": "btn btn-primary btn-xl text-left w-100"
            }, "21", component, null, 0, {
              onclick: __component.d("click", "onSubmit", false)
            });

          if (state.submitting) {
            Preloader_tag({
                class: "float-right font-medium-5",
                active: true
              }, out, __component, "22");
          } else {
            Bx_tag({
                type: "right-arrow-alt",
                class: "font-large-1 float-right white-text"
              }, out, __component, "23");
          }

          Locale_tag({
              text: "Sign In"
            }, out, __component, "24");

          out.ee();

          out.be("div", marko_attrs6, "25", component);

          route_link_tag({
              href: "/forgotten-pwd" + (state.form.email ? "?email=" + state.form.email : ""),
              class: "float-right",
              renderBody: function(out) {
                Locale_tag({
                    text: "Forgotten Password",
                    class: "font-medium-1"
                  }, out, __component, "27");
              }
            }, out, __component, "26");

          out.ee();

          out.ee();

          out.n(marko_node1, component);

          SSOAuth_tag({
              token: state.SSToken,
              excepts: [
                  state.provider
                ]
            }, out, __component, "29");

          out.ee();
        } else {
          out.be("div", marko_attrs12, "30", component);

          Row_tag({
              class: "d-flex align-items-center",
              renderBody: function(out) {
                out.be("div", marko_attrs16, "32", component);

                TenantLogo_tag({
                    style: "width:40px"
                  }, out, __component, "33");

                out.ee();

                out.be("div", marko_attrs17, "34", component);

                out.be("h4", marko_attrs18, "35", component);

                Locale_tag({
                    text: "Already have"
                  }, out, __component, "36");

                out.t(" ");

                out.t(state.tenant ? state.tenant.name : "Multipple", component);

                out.t(" ");

                Locale_tag({
                    text: "Account?"
                  }, out, __component, "37");

                out.ee();

                out.ee();
              }
            }, out, __component, "31");

          out.ee();

          out.be("div", marko_attrs13, "38", component);

          out.be("div", marko_attrs14, "39", component);

          Image_tag({
              alt: "Image",
              src: "/images/illustration/link-accounts.png",
              class: "img-fluid w-50"
            }, out, __component, "40");

          out.ee();

          out.n(marko_node2, component);

          out.n(marko_node3, component);

          FormAlert_tag({
              alert: state.alert
            }, out, __component, "43");

          out.be("p", marko_attrs15, "44", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("We couldn't find a ");

                out.t(state.tenant ? state.tenant.name : "Multipple", component);

                out.t(" account associated with that ");

                out.t(state.provider, component);

                out.t(" account. Do you want to sign in and link an existing account or continue with the new one?");
              }
            }, out, __component, "45");

          out.ee();

          out.n(marko_node4, component);

          if (input.params.errmess) {
            out.be("button", marko_attrs19, "47", component, null, 0, {
                onclick: __component.d("click", () => navigate('/'), false)
              });

            Bx_tag({
                type: "left-arrow-alt",
                class: "font-large-1"
              }, out, __component, "48");

            Locale_tag({
                text: "Back",
                class: "float-right"
              }, out, __component, "49");

            out.ee();
          } else {
            out.be("button", marko_attrs20, "50", component, null, 0, {
                onclick: __component.d("click", "onLinkAccount", false)
              });

            Bx_tag({
                type: "right-arrow-alt",
                class: "font-large-1 float-right white-text"
              }, out, __component, "51");

            Locale_tag({
                text: "Link Account"
              }, out, __component, "52");

            out.ee();

            out.be("button", marko_attrs21, "53", component, null, 0, {
                onclick: __component.d("click", "grantAccess", false, [
                    null
                  ])
              });

            Bx_tag({
                type: "right-arrow-alt",
                class: "font-large-1 float-right white-text"
              }, out, __component, "54");

            Locale_tag({
                text: "Continue"
              }, out, __component, "55");

            out.ee();
          }

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
